import { initCreditCardEntry } from '../components/credit-card-entry.js';
import { initPledgePayPage } from '../pledge-pay/pledge-pay.js';
import { initMemberOpenCreditTxModal } from './member-open-credit-tx-modal.js';
import { initUserSavedPaymentEntry } from './user-saved-payment.js';
import { initQrPayModal } from './qr-pay-modal.js';

export function initMemberPaymentDependencies() {
    initCreditCardEntry();
    initPledgePayPage();
    initUserSavedPaymentEntry();
    initMemberOpenCreditTxModal();
    if (document.getElementById('qr-pay-modal-config')) {
        initQrPayModal();
    }
}
